export default "__VITE_ASSET__DFFXKdM4__"